import { useEffect, useState } from "react"
import { ICompositeWidgetProps } from "../../LandingCompositeWidget"


const CanvasEnabled = (props: ICompositeWidgetProps): JSX.Element => {
    const [value, setValue] = useState<any[]>( props.value || props.default )

    useEffect(() => {
        setValue( props.value || props.default )
    }, [ props.value, props.default ])

    return <div className="w-100 mb-3 px-3" style={{ width: "100vw", height: "100vh" }}> 
        <div className=" overflow-y-auto d-flex flex-wrap p-2" style={{ }}>

        </div>
    </div>
}

export default CanvasEnabled
